import { ReactComponentManifest } from "web/entrypoints/common/setup";
// Components
import InStockAffiliateProductPage from "web/react/pages/product/in-stock/in-stock-affiliate/in-stock-affiliate";
import InStockECProductPage from "web/react/pages/product/in-stock/in-stock-ec/in-stock-ec";
import InStockICONProductPage from "web/react/pages/product/in-stock/in-stock-icon/in-stock-icon";
import OutOfStockProductPage from "web/react/pages/product/out-of-stock/out-of-stock/out-of-stock";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    InStockAffiliateProductPage: withRedux(InStockAffiliateProductPage),
    InStockICONProductPage: withRedux(InStockICONProductPage),
    InStockECProductPage: withRedux(InStockECProductPage),
    OutOfStockProductPage: withRedux(OutOfStockProductPage),
};

export default components;
